"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localityCommonRegion = _interopRequireDefault(require("./locality-common-region"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var LocalityCommonDistrict = {
  GREATER_QUEANBEYAN: {
    id: 2131,
    type: 'DISTRICT',
    name: 'Greater Queanbeyan',
    slug: 'greater-queanbeyan-queanbeyan-region-nsw',
    parent: _localityCommonRegion.default.QUEANBEYAN,
    metaData: {
      state: 'NSW'
    },
    districtId: 2131,
    region: _localityCommonRegion.default.QUEANBEYAN
  },
  YASS_VALLEY: {
    id: 2431,
    type: 'DISTRICT',
    name: 'Yass Valley',
    slug: 'yass-valley-southern-tablelands-nsw',
    parent: _localityCommonRegion.default.SOUTHERN_TABLELANDS,
    metaData: {
      state: 'NSW'
    },
    districtId: 2431,
    region: _localityCommonRegion.default.SOUTHERN_TABLELANDS
  }
};
var _default = exports.default = LocalityCommonDistrict;